import axios from "axios";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import GitInfo from "react-git-info/macro";
import { FormattedMessage } from "react-intl";
import { version } from "../../version";
import { useSubheader } from "../../_metronic/layout";

export const SystemStatusPage = () => {
  const suhbeader = useSubheader();
  suhbeader.setTitle("System Status");

  const gitInfo = GitInfo();

  const [status, setStatus] = useState(null);
  const fetchStatus = async () => {
    try {
      const connStatus = await axios.get(
        `${process.env.REACT_APP_URL}/api/status`
      );
      setStatus(connStatus.data);
    } catch {
      setStatus(null);
    }
  };

  useEffect(() => {
    fetchStatus();
  }, []);

  const statusOk = (status) => (
    <span className="badge badge-success">{status}</span>
  );
  const statusError = (status) => (
    <span className="badge badge-danger">{status}</span>
  );
  const statusBadge = (status) =>
    status === "OK" ? statusOk(status) : statusError(status);
  const databaseStatus = (module) =>
    module.databaseUpToDate ? (
      "OK"
    ) : module.databaseUpToDate == null ? (
      "NA"
    ) : (
      <FormattedMessage id="SYSTEM.STATUS.OUTDATED" />
    );

  return (
    <>
      <div className="card card-custom gutter-b">
        <div className="card-header border-0 py-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              <FormattedMessage id="SYSTEM.STATUS.TITLE" />
            </span>
            {/* <span className="text-muted mt-3 font-weight-bold font-size-sm">Dataflows Connection Status</span> */}
          </h3>
        </div>
        <div className="card-body pt-0 pb-3">
          <div className="table-responsive">
            <table className="table table-bordered table-vertical-top">
              <thead>
                <tr>
                  <th>
                    <FormattedMessage id="SYSTEM.MOUDLE" />
                  </th>
                  <th className="text-center">
                    <FormattedMessage id="SYSTEM.STATUS.SUBTITLE" />
                  </th>
                  <th>
                    <FormattedMessage id="SYSTEM.VERSION" />
                  </th>
                  <th>
                    <FormattedMessage id="SYSTEM.BUILD.TIME" />
                  </th>
                  <th>
                    <FormattedMessage id="SYSTEM.STATUS.DB" />
                  </th>
                </tr>
              </thead>
              <tbody>
                {status &&
                  status.map((module, moduleIndex) => (
                    <tr key={module.moduleName}>
                      <td>
                        <FormattedMessage id={module.moduleName} />
                      </td>
                      <td className="text-center">
                        {statusBadge(module.status)}
                      </td>
                      <td>{module.version}</td>
                      <td>
                        {module.buildTime
                          ? dayjs(module.buildTime).format("DD/MM/YYYY HH:mm")
                          : "NA"}
                      </td>
                      <td>{databaseStatus(module)}</td>
                    </tr>
                  ))}
              </tbody>
              <tbody>
                <tr>
                  <td>Frontend</td>
                  <td className="text-center">{statusBadge("OK")}</td>
                  <td>{version}</td>
                  <td>
                    {gitInfo.commit.date
                      ? dayjs(gitInfo.commit.date).format("DD/MM/YYYY HH:mm")
                      : "NA"}
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
